import { z, ZodType } from "zod";
import { zAttribute } from "./ZAttribute";
import { zDisplayId } from "./ZDisplayId";
import { zUid } from "./zUid";

export enum GroupType {
  Mnemonic = "Mnemonic",
  ByDictionary = "ByDictionary",
}
export const zGroupType = z.nativeEnum(GroupType);
export const zIdGroupType = z.object({
  id: zUid,
  name: zGroupType,
});
export type ZIdGroupType = z.infer<typeof zIdGroupType>;

export const zIdGroupLabel = zIdGroupType.extend({
  label: z.string(),
});
export type ZIdGroupLabel = z.infer<typeof zIdGroupLabel>;

const zGroupBase = z.object({
  id: zUid,
  name: z.string(),
  groupType: zIdGroupType,
  displayId: zDisplayId.nullish(),
  description: z.string().nullable().optional(),
  attributes: zAttribute.array().nullable().optional(),

  attributeId: zUid.nullable().optional(),
  valueId: zUid.nullable().optional(),
});

export type ZGroup = z.infer<typeof zGroupBase> & {
  groups?: ZGroup[];
};

export const zGroup = zGroupBase.extend({
  groups: z.lazy((): ZodType<ZGroup[]> => zGroup.array()).optional(),
});

// Группы, которые используются для справочников. Их нельзя использовать совместно с другими группами.

export const zDictGroup = z.object({
  id: zUid,
  name: z.string(),
  attributes: zAttribute.array().nullable().optional(),
  groupType: z.object({
    id: zUid,
    name: z.literal("Dictionary"),
  }),
});

export type ZDictGroup = z.infer<typeof zDictGroup>;
